export default __webpack_public_path__ + "static/media/sports21.8b7f3b99.jpg";